import { Menu, MenuButton, MenuItem, MenuList, Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const TASK_STATUSES = [
  'all',
  'success',
  'pending',
  'processing',
  'failure',
  'required',
  'verifying',
  'alert',
  'optional',
];

export default function StatusMenu(props: {
  selectedStatus: string;
  setSelectedStatus: (status: string) => void;
}) {
  const { t } = useTranslation();
  return (
    <Menu>
      <MenuButton variant="secondary" size="md" width="260px">
        <Text>
          {t('common.label.severity')}:&nbsp;
          {t('common.label.' + props.selectedStatus)}
        </Text>
      </MenuButton>
      <MenuList
        width="260px"
        maxHeight="400px"
        overflowX="hidden"
        overflowY="scroll"
      >
        {TASK_STATUSES.map((status, i) => {
          const onClick = props.setSelectedStatus.bind(null, status);
          return (
            <MenuItem onClick={onClick} key={i} cursor="pointer">
              {t('common.label.' + status)}
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
}
